import * as React from 'react';
import { Theme, ThemeContextType } from '../types/theme';

export const ThemeContext = React.createContext<ThemeContextType | null>(null);
interface Props {
  children: React.ReactNode;
}
const ThemeProvider: React.FC<Props> = ({ children }) => {
  const [themeMode, setThemeMode] = React.useState<Theme>('lightest');
  const [sideNavEnabled, setSideNavEnabled] = React.useState(false);
  return (
    <ThemeContext.Provider
      value={{
        theme: themeMode,
        sideNavEnabled: sideNavEnabled,
        enableSideNav: setSideNavEnabled,
        changeTheme: setThemeMode
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
